{
  "v": "4.8.0",
  "meta": { "g": "LottieFiles AE 3.5.4", "a": "", "k": "", "d": "", "tc": "" },
  "fr": 25,
  "ip": 0,
  "op": 76,
  "w": 500,
  "h": 500,
  "nm": "cart",
  "ddd": 0,
  "assets": [
    {
      "id": "comp_0",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "cart 17",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.353, "y": 1 },
                  "o": { "x": 0.739, "y": 0 },
                  "t": 6,
                  "s": [382.13, 229.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.275, "y": 1 },
                  "o": { "x": 0.84, "y": 0 },
                  "t": 16,
                  "s": [382.13, 87.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.196, "y": 0.196 },
                  "t": 23,
                  "s": [382.13, 143.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 1, "y": 0 },
                  "t": 50,
                  "s": [382.13, 143.74, 0],
                  "to": null,
                  "ti": null
                },
                { "t": 60, "s": [382.13, 229.74, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [40.303, 40.303],
                        [0.934, 39.811],
                        [0.934, -40.796],
                        [40.303, -40.303]
                      ],
                      "o": [
                        [40.303, 40.303],
                        [0.934, 39.811],
                        [0.934, -40.796],
                        [40.303, -40.303]
                      ],
                      "v": [
                        [40.303, 40.303],
                        [0.934, 39.811],
                        [0.934, -40.796],
                        [40.303, -40.303]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 20, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            }
          ],
          "ip": 6,
          "op": 756,
          "st": 6,
          "bm": 0,
          "completed": true
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "cart 16",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.353, "y": 1 },
                  "o": { "x": 0.739, "y": 0 },
                  "t": 0,
                  "s": [341.826, 199.217, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.275, "y": 1 },
                  "o": { "x": 0.84, "y": 0 },
                  "t": 10,
                  "s": [341.826, 57.217, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 1.024, "y": 1.024 },
                  "t": 18,
                  "s": [341.826, 113.217, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 1, "y": 0 },
                  "t": 50,
                  "s": [341.826, 113.217, 0],
                  "to": null,
                  "ti": null
                },
                { "t": 60, "s": [341.826, 199.217, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [40.303, 40.303],
                        [-40.303, 40.303],
                        [-40.303, -40.303],
                        [40.303, -40.303]
                      ],
                      "o": [
                        [40.303, 40.303],
                        [-40.303, 40.303],
                        [-40.303, -40.303],
                        [40.303, -40.303]
                      ],
                      "v": [
                        [40.303, 40.303],
                        [-40.303, 40.303],
                        [-40.303, -40.303],
                        [40.303, -40.303]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 20, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            }
          ],
          "ip": 0,
          "op": 750,
          "st": 0,
          "bm": 0,
          "completed": true
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "cart 15",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.353, "y": 1 },
                  "o": { "x": 0.739, "y": 0 },
                  "t": -4,
                  "s": [250, 229.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.275, "y": 1 },
                  "o": { "x": 0.84, "y": 0 },
                  "t": 6,
                  "s": [250, 87.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 1.017, "y": 1.017 },
                  "t": 14,
                  "s": [250, 143.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 1, "y": 0 },
                  "t": 50,
                  "s": [250, 143.74, 0],
                  "to": null,
                  "ti": null
                },
                { "t": 60, "s": [250, 229.74, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 1,
                        "s": [
                          {
                            "i": [
                              [41.213, -35.294],
                              [-39.394, -35.294],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [41.213, -35.294],
                              [-39.394, -35.294],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [41.213, -35.294],
                              [-39.394, -35.294],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 2,
                        "s": [
                          {
                            "i": [
                              [40.288, 15.202],
                              [-40.319, 15.202],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.288, 15.202],
                              [-40.319, 15.202],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.288, 15.202],
                              [-40.319, 15.202],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 3,
                        "s": [
                          {
                            "i": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 6,
                        "s": [
                          {
                            "i": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 7,
                        "s": [
                          {
                            "i": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 10,
                        "s": [
                          {
                            "i": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 11,
                        "s": [
                          {
                            "i": [
                              [40.86, 14.501],
                              [-39.747, 14.501],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.86, 14.501],
                              [-39.747, 14.501],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.86, 14.501],
                              [-39.747, 14.501],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 12,
                        "s": [
                          {
                            "i": [
                              [40.805, 6.188],
                              [-39.802, 6.188],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.805, 6.188],
                              [-39.802, 6.188],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.805, 6.188],
                              [-39.802, 6.188],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 13,
                        "s": [
                          {
                            "i": [
                              [40.534, 2.371],
                              [-40.073, 2.371],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.534, 2.371],
                              [-40.073, 2.371],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.534, 2.371],
                              [-40.073, 2.371],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 14,
                        "s": [
                          {
                            "i": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 50,
                        "s": [
                          {
                            "i": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 52,
                        "s": [
                          {
                            "i": [
                              [40.228, -0.32],
                              [-40.378, -0.32],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -0.32],
                              [-40.378, -0.32],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -0.32],
                              [-40.378, -0.32],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 54,
                        "s": [
                          {
                            "i": [
                              [40.228, -3.686],
                              [-40.378, -3.686],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -3.686],
                              [-40.378, -3.686],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -3.686],
                              [-40.378, -3.686],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 55,
                        "s": [
                          {
                            "i": [
                              [40.228, -9.127],
                              [-40.378, -9.127],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -9.127],
                              [-40.378, -9.127],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -9.127],
                              [-40.378, -9.127],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 56,
                        "s": [
                          {
                            "i": [
                              [40.228, -17.396],
                              [-40.378, -17.396],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -17.396],
                              [-40.378, -17.396],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -17.396],
                              [-40.378, -17.396],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "t": 57,
                        "s": [
                          {
                            "i": [
                              [40.228, -35.049],
                              [-40.378, -35.049],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -35.049],
                              [-40.378, -35.049],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -35.049],
                              [-40.378, -35.049],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      }
                    ],
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 20, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            }
          ],
          "ip": 1,
          "op": 58,
          "st": -4,
          "bm": 0,
          "completed": true
        }
      ]
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 3,
      "nm": "NULL",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 0, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.302], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 0,
              "s": [0]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.65], "y": [0] },
              "t": 9,
              "s": [-9]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.808], "y": [0] },
              "t": 15,
              "s": [0]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.967], "y": [0] },
              "t": 19,
              "s": [-4]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [1], "y": [0] },
              "t": 22,
              "s": [0]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [1], "y": [0] },
              "t": 24,
              "s": [-2]
            },
            { "t": 26, "s": [0] }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 0,
              "s": [192, 322, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 9,
              "s": [175, 322, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 15,
              "s": [223, 322, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 22,
              "s": [189, 322, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 28,
              "s": [223, 322, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 45,
              "s": [160, 322, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.167, "y": 0 },
              "t": 60,
              "s": [223, 322, 0],
              "to": null,
              "ti": null
            },
            { "t": 75, "s": [192, 322, 0] }
          ],
          "ix": 2
        },
        "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "cart 14",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [78.029, 286.105, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-44.609, 0],
                    [44.609, 0]
                  ],
                  "o": [
                    [-44.609, 0],
                    [44.609, 0]
                  ],
                  "v": [
                    [-44.609, 0],
                    [44.609, 0]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 67,
                "s": [97]
              },
              { "t": 75, "s": [36] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 28,
                "s": [100]
              },
              { "t": 38, "s": [36] }
            ],
            "ix": 2
          },
          "o": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 28,
                "s": [0]
              },
              { "t": 67, "s": [-1080] }
            ],
            "ix": 3
          },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 28,
      "op": 778,
      "st": 28,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "cart 13",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [66.689, 243.837, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-44.609, 0],
                    [44.609, 0]
                  ],
                  "o": [
                    [-44.609, 0],
                    [44.609, 0]
                  ],
                  "v": [
                    [-44.609, 0],
                    [44.609, 0]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 67,
                "s": [97]
              },
              { "t": 75, "s": [36] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 28,
                "s": [100]
              },
              { "t": 38, "s": [36] }
            ],
            "ix": 2
          },
          "o": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 28,
                "s": [0]
              },
              { "t": 67, "s": [-1080] }
            ],
            "ix": 3
          },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 28,
      "op": 778,
      "st": 28,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "cart 9",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [57.411, 197.446, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-44.609, 0],
                    [44.609, 0]
                  ],
                  "o": [
                    [-44.609, 0],
                    [44.609, 0]
                  ],
                  "v": [
                    [-44.609, 0],
                    [44.609, 0]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "tm",
          "s": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 67,
                "s": [97]
              },
              { "t": 75, "s": [36] }
            ],
            "ix": 1
          },
          "e": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 28,
                "s": [100]
              },
              { "t": 38, "s": [36] }
            ],
            "ix": 2
          },
          "o": {
            "a": 1,
            "k": [
              {
                "i": { "x": [0.667], "y": [1] },
                "o": { "x": [0.333], "y": [0] },
                "t": 28,
                "s": [0]
              },
              { "t": 67, "s": [-1080] }
            ],
            "ix": 3
          },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 28,
      "op": 778,
      "st": 28,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 0,
      "nm": "Pre-comp 1",
      "parent": 9,
      "refId": "comp_0",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [91.211, 28.273, 0], "ix": 2 },
        "a": { "a": 0, "k": [250, 250, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "hasMask": true,
      "masksProperties": [
        {
          "inv": true,
          "mode": "a",
          "pt": {
            "a": 0,
            "k": {
              "i": [
                [534.464, 147.423],
                [98.382, 147.423],
                [98.382, 332.99],
                [534.464, 332.99]
              ],
              "o": [
                [534.464, 147.423],
                [98.382, 147.423],
                [98.382, 332.99],
                [534.464, 332.99]
              ],
              "v": [
                [534.464, 147.423],
                [98.382, 147.423],
                [98.382, 332.99],
                [534.464, 332.99]
              ],
              "c": true
            },
            "ix": 1
          },
          "o": { "a": 0, "k": 100, "ix": 3 },
          "x": { "a": 0, "k": 0, "ix": 4 },
          "nm": "Mask 1"
        }
      ],
      "w": 500,
      "h": 500,
      "ip": 15,
      "op": 765,
      "st": 15,
      "bm": 0,
      "completed": true,
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "cart 17",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.353, "y": 1 },
                  "o": { "x": 0.739, "y": 0 },
                  "t": 6,
                  "s": [382.13, 229.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.275, "y": 1 },
                  "o": { "x": 0.84, "y": 0 },
                  "t": 16,
                  "s": [382.13, 87.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.196, "y": 0.196 },
                  "t": 23,
                  "s": [382.13, 143.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 1, "y": 0 },
                  "t": 50,
                  "s": [382.13, 143.74, 0],
                  "to": null,
                  "ti": null
                },
                { "t": 60, "s": [382.13, 229.74, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [40.303, 40.303],
                        [0.934, 39.811],
                        [0.934, -40.796],
                        [40.303, -40.303]
                      ],
                      "o": [
                        [40.303, 40.303],
                        [0.934, 39.811],
                        [0.934, -40.796],
                        [40.303, -40.303]
                      ],
                      "v": [
                        [40.303, 40.303],
                        [0.934, 39.811],
                        [0.934, -40.796],
                        [40.303, -40.303]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 20, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            }
          ],
          "ip": 6,
          "op": 756,
          "st": 6,
          "bm": 0,
          "completed": true
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "cart 16",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.353, "y": 1 },
                  "o": { "x": 0.739, "y": 0 },
                  "t": 0,
                  "s": [341.826, 199.217, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.275, "y": 1 },
                  "o": { "x": 0.84, "y": 0 },
                  "t": 10,
                  "s": [341.826, 57.217, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 1.024, "y": 1.024 },
                  "t": 18,
                  "s": [341.826, 113.217, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 1, "y": 0 },
                  "t": 50,
                  "s": [341.826, 113.217, 0],
                  "to": null,
                  "ti": null
                },
                { "t": 60, "s": [341.826, 199.217, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [40.303, 40.303],
                        [-40.303, 40.303],
                        [-40.303, -40.303],
                        [40.303, -40.303]
                      ],
                      "o": [
                        [40.303, 40.303],
                        [-40.303, 40.303],
                        [-40.303, -40.303],
                        [40.303, -40.303]
                      ],
                      "v": [
                        [40.303, 40.303],
                        [-40.303, 40.303],
                        [-40.303, -40.303],
                        [40.303, -40.303]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 20, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            }
          ],
          "ip": 0,
          "op": 750,
          "st": 0,
          "bm": 0,
          "completed": true
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "cart 15",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.353, "y": 1 },
                  "o": { "x": 0.739, "y": 0 },
                  "t": -4,
                  "s": [250, 229.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.275, "y": 1 },
                  "o": { "x": 0.84, "y": 0 },
                  "t": 6,
                  "s": [250, 87.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 1.017, "y": 1.017 },
                  "t": 14,
                  "s": [250, 143.74, 0],
                  "to": null,
                  "ti": null
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 1, "y": 0 },
                  "t": 50,
                  "s": [250, 143.74, 0],
                  "to": null,
                  "ti": null
                },
                { "t": 60, "s": [250, 229.74, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 1,
                        "s": [
                          {
                            "i": [
                              [41.213, -35.294],
                              [-39.394, -35.294],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [41.213, -35.294],
                              [-39.394, -35.294],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [41.213, -35.294],
                              [-39.394, -35.294],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 2,
                        "s": [
                          {
                            "i": [
                              [40.288, 15.202],
                              [-40.319, 15.202],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.288, 15.202],
                              [-40.319, 15.202],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.288, 15.202],
                              [-40.319, 15.202],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 3,
                        "s": [
                          {
                            "i": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 6,
                        "s": [
                          {
                            "i": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 7,
                        "s": [
                          {
                            "i": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 10,
                        "s": [
                          {
                            "i": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.303, 40.303],
                              [-40.303, 40.303],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 11,
                        "s": [
                          {
                            "i": [
                              [40.86, 14.501],
                              [-39.747, 14.501],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.86, 14.501],
                              [-39.747, 14.501],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.86, 14.501],
                              [-39.747, 14.501],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 12,
                        "s": [
                          {
                            "i": [
                              [40.805, 6.188],
                              [-39.802, 6.188],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.805, 6.188],
                              [-39.802, 6.188],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.805, 6.188],
                              [-39.802, 6.188],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 13,
                        "s": [
                          {
                            "i": [
                              [40.534, 2.371],
                              [-40.073, 2.371],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.534, 2.371],
                              [-40.073, 2.371],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.534, 2.371],
                              [-40.073, 2.371],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 14,
                        "s": [
                          {
                            "i": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 50,
                        "s": [
                          {
                            "i": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, 2.553],
                              [-40.378, 2.553],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 52,
                        "s": [
                          {
                            "i": [
                              [40.228, -0.32],
                              [-40.378, -0.32],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -0.32],
                              [-40.378, -0.32],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -0.32],
                              [-40.378, -0.32],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 54,
                        "s": [
                          {
                            "i": [
                              [40.228, -3.686],
                              [-40.378, -3.686],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -3.686],
                              [-40.378, -3.686],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -3.686],
                              [-40.378, -3.686],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 55,
                        "s": [
                          {
                            "i": [
                              [40.228, -9.127],
                              [-40.378, -9.127],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -9.127],
                              [-40.378, -9.127],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -9.127],
                              [-40.378, -9.127],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 56,
                        "s": [
                          {
                            "i": [
                              [40.228, -17.396],
                              [-40.378, -17.396],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -17.396],
                              [-40.378, -17.396],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -17.396],
                              [-40.378, -17.396],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "t": 57,
                        "s": [
                          {
                            "i": [
                              [40.228, -35.049],
                              [-40.378, -35.049],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "o": [
                              [40.228, -35.049],
                              [-40.378, -35.049],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "v": [
                              [40.228, -35.049],
                              [-40.378, -35.049],
                              [-40.303, -40.303],
                              [40.303, -40.303]
                            ],
                            "c": true
                          }
                        ]
                      }
                    ],
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 20, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false,
                  "_render": true
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform",
                  "_render": true
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false,
              "_render": true
            }
          ],
          "ip": 1,
          "op": 58,
          "st": -4,
          "bm": 0,
          "completed": true
        }
      ]
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "cart 12",
      "parent": 9,
      "hd": true,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.353, "y": 1 },
              "o": { "x": 0.739, "y": 0 },
              "t": 21,
              "s": [223.341, 8.013, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.275, "y": 1 },
              "o": { "x": 0.84, "y": 0 },
              "t": 31,
              "s": [223.341, -133.987, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 0.667 },
              "o": { "x": 0.196, "y": 0.196 },
              "t": 38,
              "s": [223.341, -77.987, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 1, "y": 0 },
              "t": 65,
              "s": [223.341, -77.987, 0],
              "to": null,
              "ti": null
            },
            { "t": 75, "s": [223.341, 8.013, 0] }
          ],
          "ix": 2
        },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "hasMask": true,
      "masksProperties": [
        {
          "inv": true,
          "mode": "a",
          "pt": {
            "a": 1,
            "k": [
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 21,
                "s": [
                  {
                    "i": [
                      [-178.786, -78.547],
                      [-178.786, 57.685],
                      [71.73, 57.685],
                      [71.73, -78.547]
                    ],
                    "o": [
                      [-178.786, -78.547],
                      [-178.786, 57.685],
                      [71.73, 57.685],
                      [71.73, -78.547]
                    ],
                    "v": [
                      [-178.786, -78.547],
                      [-178.786, 57.685],
                      [71.73, 57.685],
                      [71.73, -78.547]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 25,
                "s": [
                  {
                    "i": [
                      [-177.894, -56.012],
                      [-177.894, 80.219],
                      [72.622, 80.219],
                      [72.622, -56.012]
                    ],
                    "o": [
                      [-177.894, -56.012],
                      [-177.894, 80.219],
                      [72.622, 80.219],
                      [72.622, -56.012]
                    ],
                    "v": [
                      [-177.894, -56.012],
                      [-177.894, 80.219],
                      [72.622, 80.219],
                      [72.622, -56.012]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 26,
                "s": [
                  {
                    "i": [
                      [-179.392, -28.501],
                      [-179.392, 107.73],
                      [71.123, 107.73],
                      [71.123, -28.501]
                    ],
                    "o": [
                      [-179.392, -28.501],
                      [-179.392, 107.73],
                      [71.123, 107.73],
                      [71.123, -28.501]
                    ],
                    "v": [
                      [-179.392, -28.501],
                      [-179.392, 107.73],
                      [71.123, 107.73],
                      [71.123, -28.501]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 27,
                "s": [
                  {
                    "i": [
                      [-180.351, 18.321],
                      [-180.351, 154.553],
                      [70.164, 154.553],
                      [70.164, 18.321]
                    ],
                    "o": [
                      [-180.351, 18.321],
                      [-180.351, 154.553],
                      [70.164, 154.553],
                      [70.164, 18.321]
                    ],
                    "v": [
                      [-180.351, 18.321],
                      [-180.351, 154.553],
                      [70.164, 154.553],
                      [70.164, 18.321]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 28,
                "s": [
                  {
                    "i": [
                      [-180.624, 42.474],
                      [-180.624, 178.705],
                      [69.892, 178.705],
                      [69.892, 42.474]
                    ],
                    "o": [
                      [-180.624, 42.474],
                      [-180.624, 178.705],
                      [69.892, 178.705],
                      [69.892, 42.474]
                    ],
                    "v": [
                      [-180.624, 42.474],
                      [-180.624, 178.705],
                      [69.892, 178.705],
                      [69.892, 42.474]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 31,
                "s": [
                  {
                    "i": [
                      [-175.667, 60.895],
                      [-175.667, 197.126],
                      [74.849, 197.126],
                      [74.849, 60.895]
                    ],
                    "o": [
                      [-175.667, 60.895],
                      [-175.667, 197.126],
                      [74.849, 197.126],
                      [74.849, 60.895]
                    ],
                    "v": [
                      [-175.667, 60.895],
                      [-175.667, 197.126],
                      [74.849, 197.126],
                      [74.849, 60.895]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 34,
                "s": [
                  {
                    "i": [
                      [-176.159, 50.45],
                      [-176.159, 186.681],
                      [74.357, 186.681],
                      [74.357, 50.45]
                    ],
                    "o": [
                      [-176.159, 50.45],
                      [-176.159, 186.681],
                      [74.357, 186.681],
                      [74.357, 50.45]
                    ],
                    "v": [
                      [-176.159, 50.45],
                      [-176.159, 186.681],
                      [74.357, 186.681],
                      [74.357, 50.45]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 36,
                "s": [
                  {
                    "i": [
                      [-174.253, 6.373],
                      [-174.253, 142.605],
                      [76.262, 142.605],
                      [76.262, 6.373]
                    ],
                    "o": [
                      [-174.253, 6.373],
                      [-174.253, 142.605],
                      [76.262, 142.605],
                      [76.262, 6.373]
                    ],
                    "v": [
                      [-174.253, 6.373],
                      [-174.253, 142.605],
                      [76.262, 142.605],
                      [76.262, 6.373]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 38,
                "s": [
                  {
                    "i": [
                      [-174.409, 7.658],
                      [-174.409, 143.889],
                      [76.106, 143.889],
                      [76.106, 7.658]
                    ],
                    "o": [
                      [-174.409, 7.658],
                      [-174.409, 143.889],
                      [76.106, 143.889],
                      [76.106, 7.658]
                    ],
                    "v": [
                      [-174.409, 7.658],
                      [-174.409, 143.889],
                      [76.106, 143.889],
                      [76.106, 7.658]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 65,
                "s": [
                  {
                    "i": [
                      [-174.409, 7.658],
                      [-174.409, 143.889],
                      [76.106, 143.889],
                      [76.106, 7.658]
                    ],
                    "o": [
                      [-174.409, 7.658],
                      [-174.409, 143.889],
                      [76.106, 143.889],
                      [76.106, 7.658]
                    ],
                    "v": [
                      [-174.409, 7.658],
                      [-174.409, 143.889],
                      [76.106, 143.889],
                      [76.106, 7.658]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 70,
                "s": [
                  {
                    "i": [
                      [-174.365, -9.868],
                      [-174.365, 126.363],
                      [76.151, 126.363],
                      [76.151, -9.868]
                    ],
                    "o": [
                      [-174.365, -9.868],
                      [-174.365, 126.363],
                      [76.151, 126.363],
                      [76.151, -9.868]
                    ],
                    "v": [
                      [-174.365, -9.868],
                      [-174.365, 126.363],
                      [76.151, 126.363],
                      [76.151, -9.868]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 71,
                "s": [
                  {
                    "i": [
                      [-174.523, -14.817],
                      [-174.523, 121.415],
                      [75.993, 121.415],
                      [75.993, -14.817]
                    ],
                    "o": [
                      [-174.523, -14.817],
                      [-174.523, 121.415],
                      [75.993, 121.415],
                      [75.993, -14.817]
                    ],
                    "v": [
                      [-174.523, -14.817],
                      [-174.523, 121.415],
                      [75.993, 121.415],
                      [75.993, -14.817]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "t": 75,
                "s": [
                  {
                    "i": [
                      [-174.847, -81.002],
                      [-174.847, 55.229],
                      [75.668, 55.229],
                      [75.668, -81.002]
                    ],
                    "o": [
                      [-174.847, -81.002],
                      [-174.847, 55.229],
                      [75.668, 55.229],
                      [75.668, -81.002]
                    ],
                    "v": [
                      [-174.847, -81.002],
                      [-174.847, 55.229],
                      [75.668, 55.229],
                      [75.668, -81.002]
                    ],
                    "c": true
                  }
                ]
              }
            ],
            "ix": 1
          },
          "o": { "a": 0, "k": 100, "ix": 3 },
          "x": { "a": 0, "k": 0, "ix": 4 },
          "nm": "Mask 1"
        }
      ],
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [40.303, 40.303],
                    [0.934, 39.811],
                    [0.934, -40.796],
                    [40.303, -40.303]
                  ],
                  "o": [
                    [40.303, 40.303],
                    [0.934, 39.811],
                    [0.934, -40.796],
                    [40.303, -40.303]
                  ],
                  "v": [
                    [40.303, 40.303],
                    [0.934, 39.811],
                    [0.934, -40.796],
                    [40.303, -40.303]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 21,
      "op": 771,
      "st": 21,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "cart 11",
      "parent": 9,
      "hd": true,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.353, "y": 1 },
              "o": { "x": 0.739, "y": 0 },
              "t": 15,
              "s": [183.037, -22.511, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.275, "y": 1 },
              "o": { "x": 0.84, "y": 0 },
              "t": 25,
              "s": [183.037, -164.511, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 0.667 },
              "o": { "x": 1.024, "y": 1.024 },
              "t": 33,
              "s": [183.037, -108.511, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 1, "y": 0 },
              "t": 65,
              "s": [183.037, -108.511, 0],
              "to": null,
              "ti": null
            },
            { "t": 75, "s": [183.037, -22.511, 0] }
          ],
          "ix": 2
        },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "hasMask": true,
      "masksProperties": [
        {
          "inv": true,
          "mode": "a",
          "pt": {
            "a": 1,
            "k": [
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 15,
                "s": [
                  {
                    "i": [
                      [-108.852, -50.554],
                      [-108.852, 86.842],
                      [96.303, 86.842],
                      [96.303, -50.554]
                    ],
                    "o": [
                      [-108.852, -50.554],
                      [-108.852, 86.842],
                      [96.303, 86.842],
                      [96.303, -50.554]
                    ],
                    "v": [
                      [-108.852, -50.554],
                      [-108.852, 86.842],
                      [96.303, 86.842],
                      [96.303, -50.554]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 18,
                "s": [
                  {
                    "i": [
                      [-112.839, -38.166],
                      [-112.839, 99.23],
                      [92.315, 99.23],
                      [92.315, -38.166]
                    ],
                    "o": [
                      [-112.839, -38.166],
                      [-112.839, 99.23],
                      [92.315, 99.23],
                      [92.315, -38.166]
                    ],
                    "v": [
                      [-112.839, -38.166],
                      [-112.839, 99.23],
                      [92.315, 99.23],
                      [92.315, -38.166]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 20,
                "s": [
                  {
                    "i": [
                      [-110.408, 2.522],
                      [-110.408, 139.918],
                      [94.746, 139.918],
                      [94.746, 2.522]
                    ],
                    "o": [
                      [-110.408, 2.522],
                      [-110.408, 139.918],
                      [94.746, 139.918],
                      [94.746, 2.522]
                    ],
                    "v": [
                      [-110.408, 2.522],
                      [-110.408, 139.918],
                      [94.746, 139.918],
                      [94.746, 2.522]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 21,
                "s": [
                  {
                    "i": [
                      [-111.773, 47.304],
                      [-111.773, 184.7],
                      [93.382, 184.7],
                      [93.382, 47.304]
                    ],
                    "o": [
                      [-111.773, 47.304],
                      [-111.773, 184.7],
                      [93.382, 184.7],
                      [93.382, 47.304]
                    ],
                    "v": [
                      [-111.773, 47.304],
                      [-111.773, 184.7],
                      [93.382, 184.7],
                      [93.382, 47.304]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 23,
                "s": [
                  {
                    "i": [
                      [-113.078, 81.13],
                      [-113.078, 218.526],
                      [92.076, 218.526],
                      [92.076, 81.13]
                    ],
                    "o": [
                      [-113.078, 81.13],
                      [-113.078, 218.526],
                      [92.076, 218.526],
                      [92.076, 81.13]
                    ],
                    "v": [
                      [-113.078, 81.13],
                      [-113.078, 218.526],
                      [92.076, 218.526],
                      [92.076, 81.13]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 25,
                "s": [
                  {
                    "i": [
                      [-114.061, 90.587],
                      [-114.061, 227.983],
                      [91.094, 227.983],
                      [91.094, 90.587]
                    ],
                    "o": [
                      [-114.061, 90.587],
                      [-114.061, 227.983],
                      [91.094, 227.983],
                      [91.094, 90.587]
                    ],
                    "v": [
                      [-114.061, 90.587],
                      [-114.061, 227.983],
                      [91.094, 227.983],
                      [91.094, 90.587]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 31,
                "s": [
                  {
                    "i": [
                      [-113.711, 39.298],
                      [-113.711, 176.695],
                      [91.443, 176.695],
                      [91.443, 39.298]
                    ],
                    "o": [
                      [-113.711, 39.298],
                      [-113.711, 176.695],
                      [91.443, 176.695],
                      [91.443, 39.298]
                    ],
                    "v": [
                      [-113.711, 39.298],
                      [-113.711, 176.695],
                      [91.443, 176.695],
                      [91.443, 39.298]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 33,
                "s": [
                  {
                    "i": [
                      [-113.801, 35.948],
                      [-113.801, 173.344],
                      [91.353, 173.344],
                      [91.353, 35.948]
                    ],
                    "o": [
                      [-113.801, 35.948],
                      [-113.801, 173.344],
                      [91.353, 173.344],
                      [91.353, 35.948]
                    ],
                    "v": [
                      [-113.801, 35.948],
                      [-113.801, 173.344],
                      [91.353, 173.344],
                      [91.353, 35.948]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 65,
                "s": [
                  {
                    "i": [
                      [-113.801, 35.948],
                      [-113.801, 173.344],
                      [91.353, 173.344],
                      [91.353, 35.948]
                    ],
                    "o": [
                      [-113.801, 35.948],
                      [-113.801, 173.344],
                      [91.353, 173.344],
                      [91.353, 35.948]
                    ],
                    "v": [
                      [-113.801, 35.948],
                      [-113.801, 173.344],
                      [91.353, 173.344],
                      [91.353, 35.948]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 70,
                "s": [
                  {
                    "i": [
                      [-113.881, 27.7],
                      [-113.881, 165.097],
                      [91.274, 165.097],
                      [91.274, 27.7]
                    ],
                    "o": [
                      [-113.881, 27.7],
                      [-113.881, 165.097],
                      [91.274, 165.097],
                      [91.274, 27.7]
                    ],
                    "v": [
                      [-113.881, 27.7],
                      [-113.881, 165.097],
                      [91.274, 165.097],
                      [91.274, 27.7]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 73,
                "s": [
                  {
                    "i": [
                      [-114.141, -25.083],
                      [-114.141, 112.313],
                      [91.014, 112.313],
                      [91.014, -25.083]
                    ],
                    "o": [
                      [-114.141, -25.083],
                      [-114.141, 112.313],
                      [91.014, 112.313],
                      [91.014, -25.083]
                    ],
                    "v": [
                      [-114.141, -25.083],
                      [-114.141, 112.313],
                      [91.014, 112.313],
                      [91.014, -25.083]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "i": { "x": 0.833, "y": 0.833 },
                "o": { "x": 0.167, "y": 0.167 },
                "t": 74,
                "s": [
                  {
                    "i": [
                      [-113.385, -45.083],
                      [-113.385, 92.313],
                      [91.769, 92.313],
                      [91.769, -45.083]
                    ],
                    "o": [
                      [-113.385, -45.083],
                      [-113.385, 92.313],
                      [91.769, 92.313],
                      [91.769, -45.083]
                    ],
                    "v": [
                      [-113.385, -45.083],
                      [-113.385, 92.313],
                      [91.769, 92.313],
                      [91.769, -45.083]
                    ],
                    "c": true
                  }
                ]
              },
              {
                "t": 75,
                "s": [
                  {
                    "i": [
                      [-113.612, -46.526],
                      [-113.612, 90.87],
                      [91.543, 90.87],
                      [91.543, -46.526]
                    ],
                    "o": [
                      [-113.612, -46.526],
                      [-113.612, 90.87],
                      [91.543, 90.87],
                      [91.543, -46.526]
                    ],
                    "v": [
                      [-113.612, -46.526],
                      [-113.612, 90.87],
                      [91.543, 90.87],
                      [91.543, -46.526]
                    ],
                    "c": true
                  }
                ]
              }
            ],
            "ix": 1
          },
          "o": { "a": 0, "k": 100, "ix": 3 },
          "x": { "a": 0, "k": 0, "ix": 4 },
          "nm": "Mask 1"
        }
      ],
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [40.303, 40.303],
                    [-40.303, 40.303],
                    [-40.303, -40.303],
                    [40.303, -40.303]
                  ],
                  "o": [
                    [40.303, 40.303],
                    [-40.303, 40.303],
                    [-40.303, -40.303],
                    [40.303, -40.303]
                  ],
                  "v": [
                    [40.303, 40.303],
                    [-40.303, 40.303],
                    [-40.303, -40.303],
                    [40.303, -40.303]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 15,
      "op": 765,
      "st": 15,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 8,
      "ty": 4,
      "nm": "cart 10",
      "parent": 9,
      "hd": true,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.353, "y": 1 },
              "o": { "x": 0.739, "y": 0 },
              "t": 11,
              "s": [91.211, 8.013, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.275, "y": 1 },
              "o": { "x": 0.84, "y": 0 },
              "t": 21,
              "s": [91.211, -133.987, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 0.667 },
              "o": { "x": 1.017, "y": 1.017 },
              "t": 29,
              "s": [91.211, -77.987, 0],
              "to": null,
              "ti": null
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 1, "y": 0 },
              "t": 65,
              "s": [91.211, -77.987, 0],
              "to": null,
              "ti": null
            },
            { "t": 75, "s": [91.211, 8.013, 0] }
          ],
          "ix": 2
        },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 16,
                    "s": [
                      {
                        "i": [
                          [41.213, -35.294],
                          [-39.394, -35.294],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [41.213, -35.294],
                          [-39.394, -35.294],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [41.213, -35.294],
                          [-39.394, -35.294],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 17,
                    "s": [
                      {
                        "i": [
                          [40.288, 15.202],
                          [-40.319, 15.202],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.288, 15.202],
                          [-40.319, 15.202],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.288, 15.202],
                          [-40.319, 15.202],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 18,
                    "s": [
                      {
                        "i": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 21,
                    "s": [
                      {
                        "i": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 22,
                    "s": [
                      {
                        "i": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 25,
                    "s": [
                      {
                        "i": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.303, 40.303],
                          [-40.303, 40.303],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 26,
                    "s": [
                      {
                        "i": [
                          [40.86, 14.501],
                          [-39.747, 14.501],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.86, 14.501],
                          [-39.747, 14.501],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.86, 14.501],
                          [-39.747, 14.501],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 27,
                    "s": [
                      {
                        "i": [
                          [40.805, 6.188],
                          [-39.802, 6.188],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.805, 6.188],
                          [-39.802, 6.188],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.805, 6.188],
                          [-39.802, 6.188],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 28,
                    "s": [
                      {
                        "i": [
                          [40.534, 2.371],
                          [-40.073, 2.371],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.534, 2.371],
                          [-40.073, 2.371],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.534, 2.371],
                          [-40.073, 2.371],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 29,
                    "s": [
                      {
                        "i": [
                          [40.228, 2.553],
                          [-40.378, 2.553],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.228, 2.553],
                          [-40.378, 2.553],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.228, 2.553],
                          [-40.378, 2.553],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 65,
                    "s": [
                      {
                        "i": [
                          [40.228, 2.553],
                          [-40.378, 2.553],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.228, 2.553],
                          [-40.378, 2.553],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.228, 2.553],
                          [-40.378, 2.553],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 67,
                    "s": [
                      {
                        "i": [
                          [40.228, -0.32],
                          [-40.378, -0.32],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.228, -0.32],
                          [-40.378, -0.32],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.228, -0.32],
                          [-40.378, -0.32],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 69,
                    "s": [
                      {
                        "i": [
                          [40.228, -3.686],
                          [-40.378, -3.686],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.228, -3.686],
                          [-40.378, -3.686],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.228, -3.686],
                          [-40.378, -3.686],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 70,
                    "s": [
                      {
                        "i": [
                          [40.228, -9.127],
                          [-40.378, -9.127],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.228, -9.127],
                          [-40.378, -9.127],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.228, -9.127],
                          [-40.378, -9.127],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 71,
                    "s": [
                      {
                        "i": [
                          [40.228, -17.396],
                          [-40.378, -17.396],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.228, -17.396],
                          [-40.378, -17.396],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.228, -17.396],
                          [-40.378, -17.396],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 72,
                    "s": [
                      {
                        "i": [
                          [40.228, -35.049],
                          [-40.378, -35.049],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "o": [
                          [40.228, -35.049],
                          [-40.378, -35.049],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "v": [
                          [40.228, -35.049],
                          [-40.378, -35.049],
                          [-40.303, -40.303],
                          [40.303, -40.303]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 16,
      "op": 73,
      "st": 11,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 9,
      "ty": 3,
      "nm": "NULL CONTROL",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 0, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.443], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 2,
              "s": [0]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.613], "y": [0] },
              "t": 11,
              "s": [-5]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.753], "y": [0] },
              "t": 17,
              "s": [6]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.893], "y": [0] },
              "t": 21,
              "s": [-2]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [1], "y": [0] },
              "t": 24,
              "s": [1]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [1], "y": [0] },
              "t": 26,
              "s": [-2]
            },
            { "t": 28, "s": [0] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [86.789, 19.727, 0], "ix": 2 },
        "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 10,
      "ty": 4,
      "nm": "cart 8",
      "parent": 9,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [155.413, 0.553, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-118.727, 0],
                    [118.727, 0]
                  ],
                  "o": [
                    [-118.727, 0],
                    [118.727, 0]
                  ],
                  "v": [
                    [-118.727, 0],
                    [118.727, 0]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 1,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 11,
      "ty": 4,
      "nm": "cart 7",
      "parent": 9,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [154.46, -4.553, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, -70.826],
                    [0, 70.826]
                  ],
                  "o": [
                    [0, -70.826],
                    [0, 70.826]
                  ],
                  "v": [
                    [0, -70.826],
                    [0, 70.826]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 1,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 12,
      "ty": 4,
      "nm": "cart 6",
      "parent": 9,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [212.425, -4.553, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [15.261, -70.826],
                    [-15.261, 70.826]
                  ],
                  "o": [
                    [15.261, -70.826],
                    [-15.261, 70.826]
                  ],
                  "v": [
                    [15.261, -70.826],
                    [-15.261, 70.826]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 1,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 13,
      "ty": 4,
      "nm": "cart 5",
      "parent": 9,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [95.575, -4.553, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-15.261, -70.826],
                    [15.261, 70.826]
                  ],
                  "o": [
                    [-15.261, -70.826],
                    [15.261, 70.826]
                  ],
                  "v": [
                    [-15.261, -70.826],
                    [15.261, 70.826]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 1,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 14,
      "ty": 4,
      "nm": "cart 4",
      "parent": 9,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [154.46, -4.553, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-133.674, -60.29900000000001],
                    [-105.02, 57.572],
                    [-96.163, 70.826],
                    [88.749, 70.826],
                    [103.774, 65.305],
                    [131.04, -49.462],
                    [125.362, -70.826],
                    [-114.156, -70.826]
                  ],
                  "o": [
                    [-131.018, -49.374],
                    [-103.12899999999999, 65.35000000000001],
                    [-88.158, 70.826],
                    [96.788, 70.826],
                    [105.632, 57.484],
                    [133.63, -60.364000000000004],
                    [114.157, -70.826],
                    [-125.399, -70.826]
                  ],
                  "v": [
                    [-131.018, -49.374],
                    [-105.02, 57.572],
                    [-88.158, 70.826],
                    [88.749, 70.826],
                    [105.632, 57.484],
                    [131.04, -49.462],
                    [114.157, -70.826],
                    [-114.156, -70.826]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 20, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 15,
      "ty": 4,
      "nm": "cart 3",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [95.119, -47.479, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [166.737, 125.315],
                    [-16.887, 125.315],
                    [-59.07, 103.24799999999999],
                    [-90.44900000000001, -32.202],
                    [-127.211, -102.429],
                    [-130.561, -102.20100000000001],
                    [-160.385, -102.2],
                    [-171.885, -107.349],
                    [-166.736, -125.2],
                    [-131.557, -125.2],
                    [-87.068, -118.39699999999999],
                    [-38.759, 84.919],
                    [-38.301, 86.801],
                    [-37.342, 91.649],
                    [-25.03, 102.315],
                    [160.385, 102.315],
                    [171.885, 107.463]
                  ],
                  "o": [
                    [160.385, 125.315],
                    [-47.672, 125.315],
                    [-63.05, 82.237],
                    [-107.02300000000001, -102.766],
                    [-130.37199999999999, -102.196],
                    [-131.037, -102.2],
                    [-166.736, -102.2],
                    [-171.885, -120.051],
                    [-160.385, -125.2],
                    [-116.62899999999999, -126.424],
                    [-67.729, -36.062],
                    [-38.351, 86.618],
                    [-38.142, 87.848],
                    [-30.816000000000003, 99.98100000000001],
                    [-16.887, 102.315],
                    [166.737, 102.315],
                    [171.885, 120.167]
                  ],
                  "v": [
                    [160.385, 125.315],
                    [-16.887, 125.315],
                    [-60.958, 90.972],
                    [-100.242, -73.896],
                    [-129.927, -102.252],
                    [-131.037, -102.2],
                    [-160.385, -102.2],
                    [-171.885, -113.7],
                    [-160.385, -125.2],
                    [-131.557, -125.2],
                    [-77.851, -79.155],
                    [-38.467, 86.136],
                    [-38.253, 87.259],
                    [-34.576, 95.18],
                    [-16.887, 102.315],
                    [160.385, 102.315],
                    [171.885, 113.815]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 16,
      "ty": 4,
      "nm": "cart 2",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [245.898, 120.67, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [28.125, -15.533],
                    [15.533, 28.125],
                    [-28.125, 15.533],
                    [-15.533, -28.125]
                  ],
                  "o": [
                    [28.125, 15.533],
                    [-15.533, 28.125],
                    [-28.125, -15.533],
                    [15.533, -28.125]
                  ],
                  "v": [
                    [28.125, 0],
                    [0, 28.125],
                    [-28.125, 0],
                    [0, -28.125]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    },
    {
      "ddd": 0,
      "ind": 17,
      "ty": 4,
      "nm": "cart",
      "parent": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [70.045, 120.67, 0], "ix": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [28.125, -15.533],
                    [15.533, 28.125],
                    [-28.125, 15.533],
                    [-15.533, -28.125]
                  ],
                  "o": [
                    [28.125, 15.533],
                    [-15.533, 28.125],
                    [-28.125, -15.533],
                    [15.533, -28.125]
                  ],
                  "v": [
                    [28.125, 0],
                    [0, 28.125],
                    [-28.125, 0],
                    [0, -28.125]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 750,
      "st": 0,
      "bm": 0,
      "completed": true
    }
  ],
  "markers": [],
  "__complete": true
}
